module.exports = __webpack_public_path__ + "img/dynamic-27.a1f83d9c.png";